<template>
  <div class="fill-height" v-if="!!this.$store.state.event">
    <ParticipantLayoutHeader v-if="!maximized" />
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.smAndUp"
      app
      :width="$vuetify.breakpoint.smAndUp ? '40vw' : '95%'"
      right
      v-model="drawer"
      :mobile-breakpoint="maximized ? -1 : 600"
      v-if="sidePaneEnabled"
    >
      <participant-chat-bar @click="drawer = !drawer" :drawer="drawer" />
    </v-navigation-drawer>
    <v-main
      style="overflow: hidden"
      :class="!maximized && $vuetify.breakpoint.smAndUp && sidePaneEnabled ? 'split-screen' : null"
    >
      <v-img
        class="page-background"
        :contain="$store.state.event.brandingContentImageExtend === 'Contain'"
        :min-height="$vuetify.breakpoint.height - $vuetify.application.bottom - $vuetify.application.top"
        :position="
          $store.state.event.brandingContentImageHorizontalAlign +
            ' ' +
            $store.state.event.brandingContentImageVerticalAlign
        "
        :src="$store.state.event.brandingContentImageUrl || ''"
        :gradient="`${combinedContentBg}, ${combinedContentBg}`"
        v-bind:style="{
          background: $store.state.event.brandingContentBackgroundColor
        }"
      >
        <v-slide-y-transition>
          <ParticipantHeader
            v-if="!$vuetify.breakpoint.smAndUp && sidePaneEnabled"
            @click="drawer = !drawer"
            :drawer="drawer"
          />
        </v-slide-y-transition>
        <router-view></router-view>
      </v-img>
    </v-main>
    <v-dialog
      max-width="500"
      :value="
        $store.state.geolocation.positionWatch !== null &&
          !$store.state.geolocation.position &&
          !geolocationPromptDismissed
      "
      overlay-opacity="0.85"
    >
      <v-card>
        <v-card-title>
          {{ $t("activity.geolocation.reminder.title") }}
        </v-card-title>
        <v-card-text>
          {{ $t("activity.geolocation.reminder.message") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="geolocationPromptDismissed = true">
            {{ $t("activity.geolocation.reminder.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showGoToLobbyPopup" max-width="500" persistent>
      <v-card>
        <v-card-title>
          {{ $t("live.activity.lobby.popup.goToLobbyTitle") }}
        </v-card-title>
        <v-card-text>
          {{ $t("live.activity.lobby.popup.goToLobbyTest") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :href="getLobbyUrl">
            {{ $t("live.activity.lobby.popup.ok") }}
          </v-btn>
          <v-btn color="secondary" @click="closeGoToLobby = true">
            {{ $t("live.activity.lobby.popup.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ParticipantChatBar from "./components/participant.chat.component";
import axios from "axios";
import ParticipantLayoutHeader from "./components/participant.layout.header";
import ParticipantHeader from "./components/participant.header";
import "animate.css";
import moment from "moment";

export default {
  components: {
    ParticipantHeader,
    ParticipantLayoutHeader,
    ParticipantChatBar
  },
  data() {
    return {
      drawer: null,
      geolocationPromptDismissed: false,
      joinedTime: null,
      joinModel: {},
      closeGoToLobby: false
    };
  },
  methods: {
    appendHelpDeskScript() {
      if (this.$store.state.event.helpDeskEmbedCodeStyle != null) {
        document.head.insertAdjacentHTML(
          "beforeend",
          `<style>${this.$store.state.event.helpDeskEmbedCodeStyle}</style>`
        );
      }

      if (this.$store.state.event.helpDeskEmbedCode != null) {
        this.$loadScript(
          `${process.env.VUE_APP_API_BASE_PATH}event/events/${this.$store.state.event.id}/getHelpDeskEmbedCode`
        );
      }
    },

    async fetchEvent() {
      const event = await axios.get(`/event/slug/${this.$route.params["event_slug"]}`);
      this.$store.commit("EVENT", event);
      document.title = event.name;
    },
    async fetchActivity() {
      const activity = await axios.get(`/event/activities/slug/${this.$route.params["activity_slug"]}`);
      activity.initDate = !!activity.date;
      activity.date = activity.date || moment().toISOString();
      this.$store.commit("ADD_ACTIVITY", activity);
      document.title = activity.event.name + " - " + activity.name;
    },
    async getOpenTokSession() {
      const data = await axios.get(`/event/activities/slug/${this.$route.params["activity_slug"]}/getSessionToken`);
      if (data.token === null || data.sessionId === null) {
        this.$store.commit("LOADING", false);
        return;
      }
      this.$store.commit("OT_TOKEN", data.token);
      this.$store.commit("OT_SESSION", data.sessionId);
    },
    async fetchTeam() {
      let teamSlug = this.$route.params["team_slug"];
      const team = await this.$axios.get(`/event/${this.$store.state.event.id}/teams/slug/${teamSlug}`);
      this.$store.commit("ADD_TEAM", team);
    },
    selectTheme() {
      this.$vuetify.theme.themes[
        this.$store.state.event.brandingTheme
      ].primary = this.$store.state.event.brandingMainColor;
      this.$vuetify.theme[this.$store.state.event.brandingTheme] = true;
    },
    hexToRgb(hex) {
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          }
        : null;
    },
    async checkAccess() {
      if (!this.$store.state.event.restrictedAccess) return;
      let checkAccess = await this.$axios.get(
        `/event/${this.$store.state.event.id}/checkAccess/${this.$route.query.accessToken}`
      );
      if (!checkAccess) {
        this.$router.push({ name: "notFound" });
      }
    },
    setJoinDate(joinModel) {
      this.joinModel = joinModel;
      this.joinedTime = new moment();
    }
  },
  async mounted() {
    this.$store.commit("LOADING", true);
    this.$store.dispatch("LOAD_SERVER_TIME");
    window.sessionStorage.setItem("accessToken", this.$route.query["accessToken"]);
    if (this.$route.params["activity_slug"]) {
      await this.fetchActivity();
    } else {
      await this.fetchEvent();
    }
    await this.checkAccess();
    this.selectTheme();
    if (this.$route.params["activity_slug"]) {
      await this.getOpenTokSession();
    }
    if (this.$route.params["team_slug"] && this.$route.params["team_slug"] != "global") {
      await this.fetchTeam();
    }
    this.$store.commit("LOADING", false);
    const onVisibilityChange = () => {
      return document.hidden;
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    this.appendHelpDeskScript();
  },

  computed: {
    currentDate() {
      return this.$store.state.serverTime;
    },
    sidePaneEnabled() {
      return (
        this.$store.state.selectedActivity &&
        this.$store.state.selectedActivity.type == "LIVE_STREAM" &&
        this.$store.state.participants &&
        this.$store.state.participants.length
      );
    },
    maximized() {
      return this.$store.state.maximized;
    },
    combinedContentBg() {
      let rgb = this.hexToRgb(this.$store.state.event.brandingContentBackgroundColor);
      return `rgba(${rgb.r},${rgb.g},${rgb.b},${1 - this.$store.state.event.brandingContentImageOpacity / 100})`;
    },
    showGoToLobbyPopup() {
      if (this.closeGoToLobby) {
        this.closeGoToLobby = false;
        return false;
      }
      if(!this.$store.state.event.enableLobby) return false;
      let activity = this.$store.state.selectedActivity;
      if (activity) {
        let mDate = null;
        if (activity.date) {
          mDate = moment(activity.date);
        } else {
          mDate = this.joinedTime;
        }
        if (mDate.add(activity.duration, "minutes").isBefore(this.currentDate)) {
          return true;
        }
        return false;
      }
      return false;
    },
    getLobbyUrl() {
      const query = this.$route.query ? Object.assign({}, this.$route.query) : {};
      if (this.joinModel.firstName) {
        query.firstName = this.joinModel.firstName;
      }
      if (this.joinModel.lastName) {
        query.lastName = this.joinModel.lastName;
      }
      if (this.joinModel.userName) {
        query.userName = this.joinModel.userName;
      }
      if (window.sessionStorage.getItem("accessToken") !== "undefined") {
        query.accessToken = window.sessionStorage.getItem("accessToken");
      }
      if (this.$route.params["team_slug"] && this.$route.params["team_slug"] != "global") {
        query.team = this.$route.params.team_slug;
      }
      return `/e/${this.$store.state.event.slug}?${new URLSearchParams(query)}`;
    }
  },
  watch: {
    maximized(maximized) {
      if (maximized) {
        setImmediate(() => (this.drawer = false));
      } else {
        setImmediate(() => (this.drawer = null));
      }
    },
  },
};
</script>

<style lang="scss">
// unscoped scss to be used in sub-components
.video-toolbar {
  z-index: 6 !important;

  &.right {
    right: 0;
  }
  &.bottom {
    bottom: 0;
    top: auto !important;
  }
  &.theme--dark.v-toolbar.v-sheet,
  &.theme--dark.v-bottom-navigation {
    background-color: rgba(39, 39, 39, 0.5);
  }
  &.theme--light.v-toolbar.v-sheet,
  &.theme--light.v-bottom-navigation {
    background-color: rgba(39, 39, 39, 0.5);
  }
}

.split-screen {
  padding-right: 40vw !important;
}

body {
  height: 100vh;
}

#app {
  min-height: 100vh;
}

.page-background > .v-responsive__sizer {
  padding-bottom: 0 !important;
}
</style>
